import { FC } from 'react';
import { Grid, Switch, Box, FormControlLabel, Checkbox, TextField } from '@mui/material';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import { DatePicker } from '@mui/x-date-pickers';
import { ActivityFormState } from 'src/types/activityFormState';

interface Props {
  formState: ActivityFormState;
  onRespondChange: (responded: boolean) => void;
  onCallDirectionChange: (direction: string) => void;
  onFollowUpDateChange: (date: string) => void;
}

const ActivityCallFields: FC<Props> = ({ formState, onRespondChange, onCallDirectionChange, onFollowUpDateChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <FormControlLabel
          title="If checked, the customer has reponded to this call"
          control={<Checkbox name="didRespond" onChange={(e) => onRespondChange(e.target.checked)} checked={formState.formActivity.didRespond ?? false} size="small" />}
          label="Has Responded"
        />
        <FormControlLabel
          title="Call Direction: Outbound calls are made by the user. Inbound calls are made by the customer."
          control={
            <Switch defaultChecked value={formState.formActivity.callDirection || 'Outbound'} onChange={(e) => onCallDirectionChange(e.target.checked ? 'Outbound' : 'Inbound')} />
          }
          label={
            <Box sx={{ display: 'flex', align: 'center' }}>
              {formState.formActivity.callDirection === 'Inbound' ? <CallReceivedIcon fontSize="small" /> : <CallMadeIcon fontSize="small" />}
              <span>{formState.formActivity.callDirection || 'Outbound'}</span>
            </Box>
          }
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box sx={{ minWidth: '200px' }}>
          <DatePicker
            views={['year', 'month', 'day']}
            label="Follow-up Date"
            value={formState.formActivity.followUpDate ? new Date(formState.formActivity.followUpDate) : null}
            onChange={(date) => onFollowUpDateChange(date ? date.toISOString() : '')}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ActivityCallFields;
